import React from 'react'
import Reflux from 'reflux'
import Store from '../store/store'

import {Redirect, Route} from 'react-router-dom'
import Login from './login/login'
import Footer from './common/footer/footer'
import Header from './common/header/header'
import Privacypolicy from './pages/privacypolicy'
import Termsandconditions from './pages/termsandconditions'
import Passwordreset from './pages/passwordreset'
import Company from './company/company'
import Customer from './customer/customer'
import Supplier from './supplier/supplier'
import Bank from './bank/bank'
import Cashregister from './cashregister/cashregister'
import Mixed from './Mixed/Mixed'
import user from '../helpers/user'
import Rules from './customer/rules'
import BankRules from './bank/bankrules'
import DetectBrowser from 'react-detect-browser'
import OldBrowser from './common/oldbrowser'
import ScrollUpButton from "react-scroll-up-button"
import Profile from './profile/profile'
import Payment from './payment/payment'
import Signup from './signup/signup'
import ForgottPassword from './forgottpassword/forgottpassword'
import ConfirmRegistration from './signup/confirmregistration'
import Onlineszamla from "./company/onlineszamla";
import PaymentFinish from "./payment/paymentfinish";
import TakarekBankReplacer from "./bank/TakarekBankReplacer";
import BankTestInput from "./bank/BankTestInput";

const browsers = {
    ie: 11,
    chrome: '68.0.3440',
    safari: '7.0.3',
    firefox: '61',
}

class AppComponent extends Reflux.Component {

    constructor() {
        super()
        this.state = {
            isGuest: user.isGuest(),
            browser: null
        }
        this.store = Store
    }

    /**
     * @deprecated To be deprecated in React v17.
     * todo: Use componentDidMount instead.
     */
    componentWillMount = () => {
        this.setState({
            isGuest: user.isGuest(),
        })
    }

    render() {
        return (
            <div className="App">
                <DetectBrowser>
                    {({browser}) => {
                        if (typeof browsers[browser.name] === 'undefined' ||
                            (typeof browsers[browser.name] !== 'undefined' && parseInt(browser.version, 0) < browsers[browser.name])) {
                            return <div><Header nolink={true}/><OldBrowser browser={browser}/></div>
                        }

                        return <div>
                            <Header nolink={false}/>
                            <Route exact path="/" render={() => (this.state.isGuest ? (<Redirect to="/login"/>) : (<Company/>))}/>

                            <Route exact
                                   path="/start/customer/:id"
                                   location={this.props.location}
                                   render={(location) => (this.state.isGuest ? (<Redirect to="/login"/>) : (<Customer location={location}/>))}/>

                            <Route exact
                                   path="/start/bank/:id"
                                   location={this.props.location}
                                   render={(location) => (this.state.isGuest ? (<Redirect to="/login"/>) : (<Bank location={location}/>))}/>

                            <Route exact
                                   path="/start/supplier/:id"
                                   location={this.props.location}
                                   render={(location) => (this.state.isGuest ? (<Redirect to="/login"/>) : (<Supplier location={location}/>))}/>

                            <Route exact
                                   path="/start/cash-register/:id"
                                   location={this.props.location}
                                   render={(location) => (this.state.isGuest ? (<Redirect to="/login"/>) : (<Cashregister location={location}/>))}/>

                            <Route exact
                                   path="/start/mixed/:id"
                                   location={this.props.location}
                                   render={(location) => (this.state.isGuest ? (<Redirect to="/login"/>) : (<Mixed location={location}/>))}/>

                            <Route exact
                                   path="/confirm-registration/:token"
                                   location={this.props.location}
                                   render={(location) => <ConfirmRegistration location={location}/>}/>

                            <Route exact
                                   path="/customer/rules/:id"
                                   location={this.props.location}
                                   render={(location) => (this.state.isGuest ? (<Redirect to="/login"/>) : (<Rules location={location}/>))}/>

                            <Route exact
                                   path="/bank/rules/:id"
                                   location={this.props.location}
                                   render={(location) => (this.state.isGuest ? (<Redirect to="/login"/>) : (<BankRules location={location}/>))}/>

                            <Route exact
                                   path="/bank/takarek-bank-replacer"
                                   location={this.props.location}
                                   render={location => (this.state.isGuest ? <Redirect to="/login"/> : <TakarekBankReplacer location={location}/>)}/>

                            <Route exact
                                   path="/bank/test-input"
                                   location={this.props.location}
                                   render={location => (this.state.isGuest ? <Redirect to="/login"/> : <BankTestInput location={location}/>)}/>


                            <Route exact path="/companies-list" render={() => (this.state.isGuest ? (<Redirect to="/login"/>) : (<Company/>))}/>

                            <Route exact
                                   path="/company/onlineszamla/:id"
                                   location={this.props.location}
                                   render={(location) => (this.state.isGuest ? (<Redirect to="/login"/>) : (<Onlineszamla location={location}/>))}/>

                            <Route exact path="/login" render={() => (!this.state.isGuest ? (<Redirect to="/"/>) : (<Login/>))}/>
                            <Route exact path="/signup" render={() => (!this.state.isGuest ? (<Redirect to="/"/>) : (<Signup/>))}/>
                            <Route exact path="/request-password-reset" render={() => (!this.state.isGuest ? (<Redirect to="/"/>) : (<Passwordreset/>))}/>
                            <Route exact path="/payment-start" render={() => (this.state.isGuest ? (<Redirect to="/"/>) : (<Payment/>))}/>

                            <Route exact
                                   path="/payment-finish"
                                   location={this.props.location}
                                   render={(location) => (this.state.isGuest ? (<Redirect to="/"/>) : (<PaymentFinish location={location}/>))}/>

                            <Route exact path="/terms-and-conditions" render={() => <Termsandconditions/>}/>
                            <Route exact path="/privacy-policy" render={() => <Privacypolicy/>}/>
                            <Route exact
                                   path="/forgott-password/:token"
                                   location={this.props.location}
                                   render={(location) => (this.state.isGuest ? (<ForgottPassword location={location}/>) : (<Redirect to="/"/>))}/>
                            <Route exact path="/user-profile"
                                   location={this.props.location}
                                   render={(location) => (this.state.isGuest ? (<Redirect to="/login"/>) : (<Profile location={location}/>))}/>
                        </div>
                    }}
                </DetectBrowser>
                <Footer/>
                <ScrollUpButton/>
            </div>
        )
    }
}

export default AppComponent



// WEBPACK FOOTER //
// ./src/components/App.js